var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 86C172 133.496 133.496 172 86 172C38.5035 172 0 133.496 0 86C0 38.5035 38.5035 0 86 0C133.496 0 172 38.5035 172 86Z",
    fill: "#F2FBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172 86C172 133.496 133.496 172 86 172C38.5035 172 0 133.496 0 86C0 38.5035 38.5035 0 86 0C133.496 0 172 38.5035 172 86Z",
    fill: "#F2FBFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172 86C172 133.496 133.496 172 86 172C38.5035 172 0 133.496 0 86C0 38.5035 38.5035 0 86 0C133.496 0 172 38.5035 172 86Z",
    fill: "#F2FBFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129 63H81.5L59 125H94C101 125 107 126 110 117C116.4 97.4 125.333 72.8333 129 63Z",
    fill: "#CAF0F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122 57H74.5L52 119H87C94 119 100 120 103 111C109.4 91.4 118.333 66.8333 122 57Z",
    fill: "#ADE8F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1278 107.5H87.1278C87.1278 114.3 90.7946 118 92.6279 119H49.1278C42.3278 119 41.6278 111.333 42.1278 107.5Z",
    fill: "#F2FBFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 111H87.5C89 116 90.7946 118 92.6279 119H49.1278C44.4999 119 43 115 42.5 111Z",
    fill: "#90E0EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73L67 91.5H103L109.5 73H74Z",
    fill: "#CAF0F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 93.5L65 95.5H101L102 93.5H66Z",
    fill: "#CAF0F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96.5L64 98.5H100L101 96.5H65Z",
    fill: "#CAF0F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99.5L63 101.5H99L100 99.5H64Z",
    fill: "#CAF0F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8108 103.5L61 105.5H90.1892L91 103.5H61.8108Z",
    fill: "#CAF0F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 61.5L86.5 50.5L83 55.5L98.5 61.5Z",
    fill: "#ADE8F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 61.5L84.5 53.5L83 55.5L98.5 61.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4271 54.632C85.875 56.9159 83.1356 57.7609 81.3084 56.5192C79.4812 55.2775 79.2582 52.4194 80.8103 50.1355C82.3624 47.8515 85.1018 47.0066 86.929 48.2482C88.7562 49.4899 88.9792 52.348 87.4271 54.632Z",
    fill: "#03045E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7206 53.4723C84.1686 55.7563 81.8111 56.8608 80.4552 55.9394C79.0992 55.0179 79.2582 52.4194 80.8103 50.1355C82.3624 47.8515 84.7198 46.747 86.0758 47.6684C87.4317 48.5899 87.2727 51.1884 85.7206 53.4723Z",
    fill: "#0077B6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0387 69.043L85.2074 65.4495H86.3243L83.0988 70.4999H81.9707L82.436 67.1214L80.2 70.4999H79.0719L79.8843 65.4495H81.0012L80.3033 69.0361L82.6336 65.4495H83.5825L83.0387 69.043Z",
    fill: "#0096C7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2365 69.4593H86.2716L85.4821 70.4999H84.2904L88.3341 65.4495H89.3726L89.3895 70.4999H88.1978L88.2365 69.4593ZM86.9112 68.6164H88.2709L88.343 66.726L86.9112 68.6164Z",
    fill: "#0096C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3204 70.4999H93.1997L92.3466 67.1769L91.0182 70.4999H89.8975L91.9165 65.4495H93.0371L93.8912 68.7794L95.2224 65.4495H96.3393L94.3204 70.4999Z",
    fill: "#0096C7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.963 66.2924H99.2971L97.6151 70.4999H96.4944L98.1765 66.2924H96.5328L96.8698 65.4495H101.3L100.963 66.2924Z",
    fill: "#0096C7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.071 68.3111H101.919L101.379 69.6639H103.904L103.57 70.4999H99.9237L101.943 65.4495H105.581L105.244 66.2924H102.726L102.245 67.496H104.397L104.071 68.3111Z",
    fill: "#0096C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.227 70.4999L106.246 65.4495H107.92C108.398 65.4495 108.785 65.5501 109.08 65.7513C109.379 65.9502 109.561 66.2346 109.624 66.6046C109.689 66.9723 109.628 67.3908 109.44 67.8602L109.347 68.0926C109.159 68.562 108.888 68.9794 108.533 69.3448C108.18 69.7102 107.774 69.9934 107.315 70.1946C106.856 70.3958 106.388 70.4975 105.912 70.4999H104.227ZM107.03 66.2924L105.682 69.6639H106.224C106.662 69.6639 107.05 69.531 107.388 69.265C107.726 68.9991 107.996 68.6187 108.199 68.1238L108.306 67.8568C108.511 67.3434 108.552 66.9549 108.428 66.6913C108.305 66.4254 108.023 66.2924 107.583 66.2924H107.03Z",
    fill: "#0096C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0885 82.6248C89.7454 82.6248 91.556 81.3656 92.1328 79.8124C92.7095 78.2592 91.8339 77 90.177 77C88.5201 77 86.7095 78.2592 86.1328 79.8124C85.556 81.3656 86.4317 82.6248 88.0885 82.6248Z",
    fill: "#90E0EF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2854 86.4558C91.3256 87.0245 91.2286 87.634 91 88.2496H81C81.2286 87.634 81.5842 87.0245 82.0467 86.4558C82.5091 85.8871 83.0692 85.3704 83.6951 84.9351C84.321 84.4999 85.0004 84.1546 85.6945 83.9191C86.3886 83.6835 87.0838 83.5622 87.7404 83.5622C88.397 83.5622 89.0022 83.6835 89.5214 83.9191C90.0405 84.1546 90.4635 84.4999 90.7662 84.9351C91.0689 85.3704 91.2453 85.8871 91.2854 86.4558Z",
    fill: "#90E0EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobs);
export default __webpack_public_path__ + "static/media/NoJobs.1a18faa486a1445f855a0daad465aa5d.svg";
export { ForwardRef as ReactComponent };